var styleDataHash = '794c77a6';  
export const injectCss = (() => {
  var css = `.qJrqT{direction:ltr}.BpK4n{direction:rtl}.H3ysy{background:transparent;border:none;cursor:pointer;display:flex;outline:none;padding-inline-end:14px;padding-inline-start:10px}.H3ysy:hover{opacity:.7}.BpK4n .H3ysy{transform:scaleX(-1)}.ea-mF{outline:none;transition:transform .15s linear;fill:#646464;color:#646464}.ea-mF.tWzaz{transform:rotate(90deg)}.M65k-{overflow-wrap:break-word;width:100%;word-break:break-word}.PRVDc{align-items:center;cursor:auto;display:flex;margin:12px 0}.PRVDc .i2H-d{flex:1}.PRVDc p[data-text-align=right][data-placeholder]:first-child:before{float:right}.PRVDc p[data-text-align=left][data-placeholder]:first-child:before{float:left}.TIeF8{margin:10px 0 12px}.EHTae{margin:0;min-height:48px}.EHTae.TIeF8{margin:2px 0}.gYCTR{cursor:auto;margin-inline-start:48px;min-height:48px;padding:9px 0;position:relative}.gYCTR:hidden{display:none}.NQNhe{align-self:start;display:flex;outline:none}.NQNhe,.czHoe{padding-top:12px}.czHoe{cursor:grab;position:absolute}.czHoe:hover{opacity:.7}.czHoe svg{fill:#646464;color:#646464}.CHJ61{right:-23px}.qBL1g{left:-23px}.t8r8W{display:flex;flex-direction:row;position:relative}.t8r8W p[data-text-align=right][data-placeholder]:first-child:before{float:right}.t8r8W p[data-text-align=left][data-placeholder]:first-child:before{float:left}.o8DgI{margin:2px 0}.B4ZR5{cursor:grabbing}.DlQ8V,.OkD6t{min-width:0;width:100%}.DlQ8V{display:flex;flex-direction:column}.omFsP{--ricos-custom-editor-add-plugin-button-position-inline-start:-36px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





